import { Component } from "react";
import { ToastContainer } from "react-toastify";
import LayoutWrapper from "../LayoutWrapper";

export class MyContentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      data: {},
      sessionsData: [],
    };
  }

  componentDidMount() {
    this.getProductDetails();
  }
  getProductDetails() {
    this.setState({
      loader: true,
    });
    let payload = {
      package_id: this.props.urlparams.packageId,
    };
    console.log({ payload });

    this.props.api
      .apiGetProductById(payload)
      .then(({ data }) => {
        this.setState({
          data,
          sessionsData: data?.sessionDetails,
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }
  handleEdit(e, values) {}
  handleDelete(e, values) {}
  handleToggle(e, values) {}
  getlinktype(e, values) {}

  getBreadcrumbs() {
    return `My Content / ${this.props.urlparams.packageName || "..."}`;
  }
  render() {
    let { loader, sessionsData, data } = this.state;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <LayoutWrapper
          title="My Content"
          back={this.getBreadcrumbs()}
          backlink="/mycontent"
        >
          <ToastContainer position="top-right" />

          {sessionsData.length > 0 && (
            <AppCurriculumAccordian
              data={sessionsData?.map((item, i) => ({
                Title: item.session_name && (() => item.session_name),
                Status: item?.status && (() => item?.status),
                Percent: item?.percent && (() => item.percent),
                Content: () => item?.session_description || "",
                Links: item.links && (() => item.links),
                record: item,
                maindata: data,
                sessiondetails:
                  this.state.sessionsData && this.state.sessionsData,
              }))}
              currentSession={false}
              handleEdit={(...args) => this.handleEdit(...args)}
              handleDelete={(...args) => this.handleDelete(...args)}
              handleToggle={(...args) => this.handleToggle(...args)}
              getlinktype={(...args) => this.getlinktype(...args)}
            ></AppCurriculumAccordian>
          )}

          {sessionsData.length == 0 && <div className="empty_layout lms"></div>}
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(MyContentDetails);
